import { AdminMuralPage } from './AdminMuralPage';

export function RedatorMuralPage() {
  return (
    <AdminMuralPage
      title="Mural"
      description="Publique avisos, links e anexos para os GTs e acompanhe as atualizações."
    />
  );
}
